// extracted by mini-css-extract-plugin
export default {"selectTerm":"OtherReasons_selectTerm__5LsXC"};